import { AlertTriangle, CircleDashed, XCircle } from 'lucide-react';
import React from 'react';
import { cn } from '@/renderer/lib/utils';
import type { DirectoryStatus } from './summaries';

const TAGS: Record<
  Exclude<DirectoryStatus, 'ok'>,
  { label: string; icon: React.ElementType; className: string }
> = {
  failing: {
    label: 'Failing',
    icon: XCircle,
    className: 'bg-red-50 text-red-700 ring-red-200',
  },
  attention: {
    label: 'Needs attention',
    icon: AlertTriangle,
    className: 'bg-amber-50 text-amber-800 ring-amber-200',
  },
  unset: {
    label: 'Not set up',
    icon: CircleDashed,
    className: 'bg-gray-50 text-gray-600 ring-gray-200',
  },
};

interface SettingsStatusTagProps {
  status: DirectoryStatus;
  className?: string;
}

/**
 * Icon + word status pill. Healthy rows render nothing: the page only
 * speaks up when something needs a decision.
 */
export const SettingsStatusTag: React.FC<SettingsStatusTagProps> = ({
  status,
  className,
}) => {
  if (status === 'ok') return null;
  const { label, icon: Icon, className: toneClassName } = TAGS[status];
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset',
        toneClassName,
        className,
      )}
    >
      <Icon size={13} strokeWidth={2.25} aria-hidden />
      {label}
    </span>
  );
};
